import { render, staticRenderFns } from "./view.html?vue&type=template&id=22c1a74f&scoped=true&"
import script from "./script.js?vue&type=script&lang=js&"
export * from "./script.js?vue&type=script&lang=js&"
import style0 from "./style.less?vue&type=style&index=0&id=22c1a74f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c1a74f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22c1a74f')) {
      api.createRecord('22c1a74f', component.options)
    } else {
      api.reload('22c1a74f', component.options)
    }
    module.hot.accept("./view.html?vue&type=template&id=22c1a74f&scoped=true&", function () {
      api.rerender('22c1a74f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/partials/tradeoffer/index.vue"
export default component.exports